document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          fetch(`${theme.routes.cart_url}.js`)
            .then((res) => res.json())
            .then((data) => {
              const itemsWithTags = this.addProductTagsToCartItems(
                data.items,
                e.detail.response.sections['cart-items']
              );
              this.checkOversizedTagsHandler(itemsWithTags);
            });
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }

          const itemsWithTags = this.addProductTagsToCartItems(
            e.detail.response.items,
            e.detail.response.sections['cart-items']
          );

          this.checkOversizedTagsHandler(itemsWithTags);
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10),
          sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('javascript');

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);
        const itemStatus = lineItemEl.dataset.itemStatus;
        const itemMaxQuantity = parseInt(lineItemEl.dataset.itemMaxquantity, 10);

        if (itemStatus === 'discontinued' && quantity > itemMaxQuantity) {
          this.$el.value = itemMaxQuantity;
        
          const errorEl = lineItemEl.querySelector('[data-cart-quantity-error]');
          if (errorEl) {
            errorEl.textContent = `You can't add more than ${itemMaxQuantity} items`;
            errorEl.classList.remove('hidden');
          }
          
          lineItemEl.classList.remove('opacity-50', 'cursor-progress');
          return;
        }

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.classList.remove('hidden');
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('cascade:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {

        const container = el.closest('li[key]');
        const itemStatus = container.dataset.itemStatus;
        const itemMaxQuantity = container.dataset.itemMaxquantity;
        
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);
        const step = parseInt(inputEl.step, 10)
        const minQuantity = parseInt(inputEl.min, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + step;
          if (itemStatus === 'discontinued' && newValue > itemMaxQuantity) { 
            newValue = itemMaxQuantity;
            const errorEl = container.querySelector('[data-cart-quantity-error]');
            if (errorEl) {
              errorEl.textContent = `You can't add more than ${itemMaxQuantity} items`;
              errorEl.classList.remove('hidden');
            }
            
            container.classList.remove('opacity-50', 'cursor-progress');
          }
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            if (lastValue > minQuantity) {
              newValue = lastValue - step;
            } else {
              newValue = minQuantity
            }
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },

      checkOversizedTagsHandler(itemsWithTags) {
        console.log('checkOversizedTagsHandler called');

        const oversizedTags = [
          theme.customSettings.oversized.oversized,
          theme.customSettings.oversized.oversized49,
          theme.customSettings.oversized.oversized75,
          theme.customSettings.oversized.oversized99,
          theme.customSettings.oversized.oversized149
        ];

        
        oversizedTags.forEach((tag) => {
          if(tag && tag.id && tag.tag) {
            this.checkOversizedTag(itemsWithTags, parseInt(tag.id), tag.tag);
          }
        });
      },

      checkOversizedTag(items, variant_id, tag_name) {
        console.log("Checking oversized tag:", tag_name, "for variant_id:", variant_id);
        let oversizedAddonId = variant_id;
        let oversizedItems = items.filter((item) => item.product_tags.includes(tag_name));
        let oversizedAddonItems = items.filter((item) => item.id === oversizedAddonId);

        const reducer = (a, c) => a + c.quantity;
        const totalDeliveryItem = oversizedItems.reduce(reducer, 0);

        console.log("Total delivery Items:", totalDeliveryItem);

        if (totalDeliveryItem === oversizedAddonItems[0]?.quantity) return;
        if (totalDeliveryItem === 0 && oversizedAddonItems.length === 0) return;

        const formData = new FormData();
        formData.append(`updates[${oversizedAddonId}]`, totalDeliveryItem);
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfigDefaults('javascript');
        config.body = formData;
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        fetch(`${theme.routes.cart_update_url}`, config)
          .then((res) => res.json())
          .then((data) => {
            document.body.dispatchEvent(
              new CustomEvent('cascade:modalcart:cartqtychange', {
                bubbles: true,
                detail: { 
                  response: data,
                  originalTarget: "",
                },
              })
            );
          })
          .catch((error) => {
            console.error('Error updating cart:', error);
          })
      },

      addProductTagsToCartItems(items, cartItemsHTML) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartItemsHTML, 'text/html');
        const cartItemElements = doc.querySelectorAll('li[data-cart-item-key]');

        const tagMap = {};
        cartItemElements.forEach(element => {
          const cartKey = element.getAttribute('data-cart-item-key');
          const tagsString = element.getAttribute('data-item-product-tags');
          
          if (cartKey && tagsString) {
            // Split tags by comma and trim whitespace
            tagMap[cartKey] = tagsString.split(',').map(tag => tag.trim());
          }
        });

        // Add tags to each item
        return items.map(item => {
          return {
            ...item,
            product_tags: tagMap[item.key] || []
          };
        });
      }
    };
  });
});
